import Utils from './../../utils/Utils';
import storage from '../../components/DeviceStorage/DeviceStorage';

declare global {
  interface Window {
    newrelic: any;
  }
}


class NewRelic {

  private _newrelic: any;

  constructor() {
    this._newrelic = window && window.newrelic ? window.newrelic : {};
  }

  recordCustomEvent(eventType: string, attributes: object) {
    try {
      this.addPageAction(eventType, attributes);
      console.log(`NewRelic event ${eventType} sent`, attributes);
    } catch (error) {
      console.error(`NewRelic event ${eventType} error`, error);
    }
  }

  addPageAction(eventName: string, information: object) {
    if (Utils.isFunction(this._newrelic.addPageAction)) {
      try {
        this._newrelic.addPageAction(eventName, information);
      } catch (error) {
        console.error('addPageAction', error)
      }
    }
  }

  actionText(action: string) {
    if (Utils.isFunction(this._newrelic.interaction)) {
      try {

        const myInteraction = this._newrelic.interaction();
        myInteraction.actionText(action)
          .save();

      } catch (error) {
        console.error('actionText', error)

      }


    }
  }


  setPageViewName(name: string, host: string) {

    try {
      if (Utils.isFunction(this._newrelic.setPageViewName)) {
        this._newrelic.setPageViewName(name, host)
      }
    } catch (error) {
      console.error('setPageViewName', error)
    }
  }

  addRelease(component: string = 'AAF component', version: string = '1.0.0') {

    try {
      if (Utils.isFunction(this._newrelic.addRelease)) {

        this._newrelic.addRelease(component, version)
      }
    } catch (error) {
      console.error('addRelease', error)
    }
  }

  addToTrace() {

    try {

      if (Utils.isFunction(this._newrelic.addToTrace)) {
        var obj = {
          // REQUIRED
          name: 'AAF Event Name GCR',
          start: 1417044274239, // Time in ms since epoch
          // OPTIONAL
          end: 1417044274252,
          // Time in ms since epoch. Defaults to same as start resulting in trace object with a duration of zero.
          origin: 'AAF Origin of event',
          // Defaults to empty string
          type: 'AAF What type of event was this'
          // Defaults to empty string
        };


        this._newrelic.addToTrace(obj)
      }
    } catch (error) {
      console.error('addToTrace', error)
    }

  }

  addEventListener() {

  }

  setInteractionNewRelic(name: string) {
    try {
      if (Utils.isFunction(this._newrelic.interaction)) {
        this._newrelic.interaction()
          .setAttribute('AAFusername', 'GCR')
          .setAttribute('AAFuserId', '007')
          .setName(name)
          .save();
      }
    } catch (error) {
      console.error('Interaction', error)
    }
  }


  setApplicationVersion(version: string = '1.0.0') {
    if (Utils.isFunction(this._newrelic.setApplicationVersion)) {
      this._newrelic.setApplicationVersion(version)
    }
  }

  setCurrentRouteName(pathname: string) {
    if (Utils.isFunction(this._newrelic.setCurrentRouteName)) {
      this._newrelic.setCurrentRouteName(pathname);
    }
  }

  setErrorHandlerNewRelic() {
    console.log('setErrorHandlerNewRelic::: ', window.newrelic.setErrorHandler !== undefined);
  }

  setUserId(userId: string = storage.getItem('user_id')) {
    if (Utils.isFunction(this._newrelic.setApplicationVersion)) {
      this._newrelic.setUserId(userId)
    }
  }
}



export default new NewRelic();



// WEBPACK FOOTER //
// ./src/utils/trackers/NewRelic.ts